import { render } from "./RegistrationBanner.vue?vue&type=template&id=6b6f6676"
import script from "./RegistrationBanner.vue?vue&type=script&lang=js"
export * from "./RegistrationBanner.vue?vue&type=script&lang=js"

import exportComponent from "/Users/widyaputra/Documents/ybpm/sch-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__